import { uniqBy } from "lodash";
import { useState, useCallback, useMemo } from "react";

import { UseDiscountCodeListFiled } from "./types";

export const useDiscountCodeListFiled: UseDiscountCodeListFiled = ({
  value,
  onChange,
}) => {
  const [isPickerModalOpen, setPickerModal] = useState(false);
  const [isFormModalOpen, setFormModal] = useState(false);

  const openPickerModal = useCallback(() => setPickerModal(true), []);
  const closePickerModal = useCallback(() => setPickerModal(false), []);

  const openFormModal = useCallback(() => setFormModal(true), []);
  const closeFormModal = useCallback(() => setFormModal(false), []);

  return useMemo(
    () => ({
      openPickerModal,
      openFormModal,
      list: {
        dataSource: value,
        pagination: false,
        onDelete: (id: number) =>
          onChange?.(value?.filter((item) => item.id !== id) || []),
      },
      picker: {
        open: isPickerModalOpen,
        destroyOnClose: true,
        onCancel: closePickerModal,
        onFinish: ({ discountCode }) => {
          if (discountCode && onChange) {
            onChange(uniqBy([...(value || []), discountCode], "id"));
          }

          closePickerModal();
        },
      },
      form: {
        open: isFormModalOpen,
        destroyOnClose: true,
        onCancel: closeFormModal,
        onFinish: ({ discountCode }) => {
          if (discountCode && onChange) {
            onChange(uniqBy([...(value || []), discountCode], "id"));
          }

          closeFormModal();
        },
      },
    }),
    [
      closeFormModal,
      closePickerModal,
      isFormModalOpen,
      isPickerModalOpen,
      onChange,
      openFormModal,
      openPickerModal,
      value,
    ]
  );
};
